import React, { useState } from 'react';
import './App.css';
import { translations } from './data/mockData';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Projects from './components/Projects';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import Process from './components/Process';
import { Toaster } from './components/ui/sonner';

function App() {
  const [language, setLanguage] = useState('es');

  return (
    <div className="App">
      <Navbar
        language={language}
        setLanguage={setLanguage}
        translations={translations}
      />
      <main>
        <Hero translations={translations} language={language} />
        <Services translations={translations} language={language} />
        <Process translations={translations} language={language} />
        <Projects translations={translations} language={language} />
        <FAQ translations={translations} language={language} />
        <ContactForm translations={translations} language={language} />
      </main>
      <Footer translations={translations} language={language} />
      <Toaster />
    </div>
  );
}

export default App;
